module.exports = __webpack_public_path__ + "media/images/landing_page/2023/album/album_large_lv-748e25b2e6aef5c976e63e63aadd7940.webp";